import type { DealerContextProps } from "@porsche-customer/slfinrtl-context-types"
import type { PropsWithChildren } from "react"
import { DealerContext } from "./DealerContext"

interface DealerContextProviderProps {
	context: DealerContextProps
}

export const DealerContextProvider = ({ children, context }: PropsWithChildren<DealerContextProviderProps>) => (
	<DealerContext.Provider value={context}>{children}</DealerContext.Provider>
)
